import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const ToggleWrapper = styled.div`
    margin: 16px 0;
`;

export const BodyWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const SimplePopoverWrapper = styled.div`
    margin-top: 16px;
    padding-bottom: 16px;
    #activation-email-template-dropdown-simple-popover[x-placement='top-start'] {
        top: 24px !important;
    }
    .customWrapperPopover {
        display: block;
    }
    .inputWrapperBasicInput {
        div:last-child {
            top: 15px;
        }
    }
`;

export const ArrowDropdownContainer = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    top: 13px;
    z-index: 1;
    right: 12px;

    svg {
        path:last-child {
            fill: ${palette.gray[7]} !important;
        }
    }
`;

export const ActivationEmailTemplateDescWrapper = styled.div`
    margin-top: 4px;
`;

export const FormPageDropdownWrapper = styled.div`
    margin-top: 16px;
`;

export const DisplayedScreenLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .Mui-disabled {
        svg path {
            fill: ${palette.gray[4]};
        }
    }
    .MuiButton-outlinedSecondary {
        span:first-child {
            margin-left: 12px;
            margin-right: 12px;
        }
    }
`;

export const ScreenDropdownWrapper = styled.div`
    width: 100%;
    margin-right: 24px;
`;

export const ExternalWebsiteInputWrapper = styled.div`
    margin-top: 16px;
`;

export const OpenInNewWrapper = styled.div`
    margin-right: 4px;
    display: flex;
    align-items: center;
`;

export const NoDataWrapper = styled.div`
    margin-top: 16px;
`;

export const LandingPageWrapper = styled.div`
    margin-top: 16px;
    #formcreator-step3-landing-page-dropdown-after-activates-simple-popover[x-placement='top'],
    #formcreator-step3-landing-page-dropdown-after-submit-simple-popover[x-placement='top'],
    #formcreator-step3-landing-page-dropdown-already-subscribed-simple-popover[x-placement='top'] {
        top: 24px !important;
    }
    .customWrapperPopover {
        display: block;
    }
`;
